import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Connector from "../Layouts/Connector";
import Error from "../Pages/Connector/Error";
import Main from "../Pages/Connector/Main";
import Settings from "../Pages/Connector/Settings";

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path=":sid" element={<Connector />}>
                    <Route index element={<Main />} />
                    <Route path="error" element={<Error />} />
                    <Route path="settings/:type" element={<Settings />} />
                </Route>
            </Routes>
        </BrowserRouter>
    )
}